/*
    开发者：cyp
    使用场景：序列区间渲染
    插件需求：d3.js,jquery.js
    参数说明：请查看下面config注释
    使用方法：
        var instance = new SeqRegion();
        instance.render(config);
*/
import * as d3 from 'd3'
import $ from 'jquery'
var SeqRegion = (function() {
    "use strict";
    let config = {
        elem: null, //html元素
        lineData: null, //[{region:[start,end],text:"content"},{region:[start,end],text:"content"}] 数组或后台数据格式
        lineColor: '#00FA9A', //区域颜色
        lineConnectData: [], //区域连线 [{dataIndex:[source,target],text:"content",<position:1>},{dataIndex:[source,target],text:"content"}] 只有detail模式下有用
        lineHeight: null, //num, 区域行高.不指定时，将自动计算，一般不建议自己设置高度
        rectData: [], //[{region:[start,end],color:"#aaa",<height:1>},{region:[start,end],color:"#aaa",<height:1>}] height可选，默认1，小于1大于0的小数，表示百分比高度，
        viewModel: 'simple', //"simple"|"detail" simple 模式无位置信息，只有线段和区间染色, detail 模式有线段位置信息
        lineDataPositions: {}, //{1:2} key表示lineData的第几个元素，value表示位置
        showAxis: true, // 是否显示坐标轴，detail下有效
        textPosition: 'inside' // inside、top、bottom
    }

    let detailPaddingLeft = 10; //detail模式下左留白
    let detailPaddingRight = 10; //detail模式下右留白
    let axisTextFontSize = 12; //坐标轴文字字体大小
    let axisScaleLenght = 15; //坐标轴刻度长度

    var SeqRegionFun = function() {}

    SeqRegionFun.prototype.render = function(_config) {
        let that = this;
        that.config = $.extend(true, {}, config, _config);
        _render(that);
    }

    SeqRegionFun.prototype.parseBackgroundData = function(data) {
        return _parseBackgroundData(data);
    }

    //渲染入库
    function _render(that) {
        $(that.config.elem).empty();
        let height = $(that.config.elem).height();
        let width = $(that.config.elem).width();
        let isSimple = that.config.viewModel == 'simple';
        let paddingLeft = isSimple ? 0 : detailPaddingLeft;
        let paddingRight = isSimple ? 0 : detailPaddingRight;
        if (!Array.isArray(that.config.lineData)) {
            let resultObj = _parseBackgroundData(that.config.lineData);
            that.config.lineData = resultObj.lineData;
            for (let i in resultObj.lineConnectData) {
                that.config.lineConnectData.push(resultObj.lineConnectData[i]);
            }
        }
        let lineData = that.config.lineData;
        let lineDataMax = _getLineDataMax(lineData);
        let pro = (width - paddingLeft - paddingRight) / lineDataMax;
        let allHeight = isSimple || !that.config.showAxis
        let mainHeightASy = _getMainHeightAY(height, allHeight, lineDataMax, that.config.textPosition);
        let lineGap = getLineGrap(mainHeightASy.height);
        let maxOverlap = _getMaxRegionOverlap(lineData, pro, lineGap);

        let lineHeight = that.config.lineHeight ? that.config.lineHeight : _getLineHeight(mainHeightASy.height, maxOverlap, lineGap);

        let dealLineData = _getDealLineData(pro, lineData, mainHeightASy.startY, mainHeightASy.height, lineHeight, maxOverlap, lineGap, paddingLeft, that.config.lineDataPositions);
        let rectData = _dealRectData(pro, that.config.rectData, paddingLeft);

        let svg = d3.select(that.config.elem).append("svg").attr("width", width).attr("height", height);

        _renderRect(svg, rectData, mainHeightASy.startY, mainHeightASy.height);
        _renderRegion(svg, dealLineData, that.config.lineColor, !isSimple, that.config.textPosition, width);
        if (!isSimple) {
            if (that.config.showAxis) {
                _renderAxis(svg, pro, lineData, mainHeightASy.startY, mainHeightASy.height, width, paddingLeft, paddingRight);
            }
            _renderRegionConnect(svg, pro, dealLineData, that.config.lineConnectData, that.config.lineColor, maxOverlap, width, lineGap, mainHeightASy.startY, lineHeight, paddingLeft, paddingRight);
        }
    }

    // 后台接口返回的数据格式解析方法
    function _parseBackgroundData(data) {
        let resultObj = {};
        let genePos = [];
        let lineConnectData = [];
        let index = 0;
        let ltrs = ['3\' LTR', '5\' LTR', '5\'LTR', '3\'LTR']
        for (let key in data) {
            let karr = key.split("|");
            let pstr = karr[0];
            let ptype = karr[1].toLowerCase()
            let ltrNote = ""
            let note = ""
            if (data[key].note) {
                ltrNote = getNote(data[key].note, false);
                note = getNote(data[key].note, true);
            } else if (data[key].gene) {
                note = getNote(data[key].gene, true);
            }
            if (arrayContain(ltrs, ltrNote)) {
                let ps = getPosition(pstr);
                genePos.push({ "region": ps, "text": ltrNote });
                index++;
            } else if (ptype == 'gene') {
                if (pstr.startsWith("join(")) {
                    let pstrarr = pstr.substring(5, pstr.length - 1).split(",");
                    for (let i = 0; i < pstrarr.length; i++) {
                        let ps = getPosition(pstrarr[i]);
                        genePos.push({ "region": ps });
                        if (i != pstrarr.length - 1) {
                            lineConnectData.push({ "dataIndex": [index, index + 1], "text": note });
                        }
                        index++;
                    }
                } else {
                    let ps = getPosition(pstr);
                    genePos.push({ "region": ps, "text": note });
                    index++;
                }
            }
        }
        resultObj.lineData = genePos;
        resultObj.lineConnectData = lineConnectData;
        return resultObj;

        function getPosition(str) {
            let start = "";
            let end = "";
            let isStart = false;
            let isEnd = false;
            for (let i = 0; i < str.length; i++) {
                let c = str[i];
                if (isNum(c)) {
                    if (!isStart && !isEnd) {
                        isStart = true;
                    }
                    if (isStart) {
                        start += c;
                    } else {
                        end += c;
                    }
                } else {
                    if (isStart) {
                        isStart = false;
                        isEnd = true;
                    }
                }
            }
            try {
                let result = [];
                result.push(parseInt(start));
                result.push(parseInt(end));
                return result;
            } catch (e) {
                return null;
            }
        }

        function isNum(str) {
            let n = Number(str);
            return !isNaN(n);
        }

        function arrayContain(arr, val) {
            for (var i in arr) {
                if (arr[i] == val) {
                    return true;
                }
            }
            return false;
        }

        function getNote(val, getfirst) {
            let note = "";
            if (val) {
                if (getfirst) {
                    let ii = val.indexOf(" ");
                    note = ii > 0 ? val.substring(0, ii) : val;
                } else {
                    note = val;
                }
            }
            if (note.startsWith('"')) {
                note = note.substring(1);
            }
            if (note.endsWith('"')) {
                note = note.substring(0, note.length - 1);
            }
            return note;
        }

    }

    function getLineGrap(height) {
        let grap = height / 14;
        grap = grap < 2 ? 2 : (grap > 10 ? 10 : grap);
        return grap;
    }

    function _getMaxRegionOverlap(lineData, pro, lineGap) {
        let overlapArr = [];
        let tw = (lineGap / 2) / pro;
        for (let i = 0; i < lineData.length; i++) {
            overlapArr.push(1);
        }

        let overlapData = [];
        for (let i = 0; i < lineData.length; i++) {
            let tData = [];
            tData.push(lineData[i]);
            for (let j = 0; j < lineData.length; j++) {
                if (i == j) {
                    continue;
                }
                if (_dataIsOverLap(lineData[i], lineData[j], tw)) {
                    tData.push(lineData[j]);
                }
            }
            overlapData.push(tData);
        }
        let max = 3;
        for (let i = 0; i < overlapData.length - 1; i++) {
            for (let j = i + 1; j < overlapData.length; j++) {
                let num = _getSameNum(overlapData[i], overlapData[j], tw);
                max = num > max ? num : max;
            }
        }
        return max;

        function _getSameNum(arr1, arr2, tw) {
            let sampleArr = [];
            for (let i in arr1) {
                for (let j in arr2) {
                    if (arr1[i] == arr2[j]) {
                        sampleArr.push(arr1[i]);
                    }
                }
            }
            let num = sampleArr.length;
            for (let i = 0; i < sampleArr.length; i++) {
                for (let j = 0; j < sampleArr.length; j++) {
                    if (i == j) {
                        continue;
                    }
                    if (sampleArr[i].region[1] + tw < sampleArr[j].region[0]) {
                        num--;
                        break;
                    }
                }
            }
            return num;
        }

        function _dataIsOverLap(data1, data2, tw) {
            let x1 = data1.region[0];
            let x2 = data1.region[1];
            let x3 = data2.region[0];
            let x4 = data2.region[1];
            return x1 < x3 && (x2 + tw) > x3 || x1 < (x4 + tw) && x2 > x4 || x3 < x1 && (x4 + tw) > x1 || x3 < (x2 + tw) && x4 > x2;
        }
    }

    function _isOverLap(x1, x2, x3, x4) {
        return x1 < x3 && x2 > x3 || x1 < x4 && x2 > x4 || x3 < x1 && x4 > x1 || x3 < x2 && x4 > x2;
    }

    //获取中间区域高度,allHeight为true时返回全部高度，否则返回中间的一半高度，上下两边用于画坐标轴
    function _getMainHeightAY(height, allHeight, lineDataMax, textPosition) {
        let maxDataLenght = (lineDataMax + "").length;
        let obj = {};
        if (allHeight) {
            obj.height = height;
            obj.startY = 0;
        } else {
            let axisHeight = axisScaleLenght + 16 + axisTextFontSize * maxDataLenght;
            obj.height = height - axisHeight * 2;
            obj.startY = axisHeight;
        }
        if (textPosition && textPosition != 'inside') {
            if (textPosition == 'top') {
                obj.startY += 24
                obj.height -= 24;
            } else if (textPosition == 'bottom') {
                obj.height -= 24;
            }
        }
        return obj;
    }

    //获取线段高度
    function _getLineHeight(mainHeight, maxOverlap, lineGap) {
        return (mainHeight - (maxOverlap - 1) * lineGap) / maxOverlap;
    }

    //渲染区间直接的连线，难点在于算出两个区间之间的连线路径
    function _renderRegionConnect(svg, pro, dealLineData, lineConnectData, lineColor, maxOverlap, width, lineGap, startY, lineHeight, paddingLeft, paddingRight) {
        let allPointArrs = [];
        for (let i in lineConnectData) {
            let sourceIndex = lineConnectData[i].dataIndex[0];
            let targetIndex = lineConnectData[i].dataIndex[1];
            let lineText = lineConnectData[i].text;
            let source = null;
            let target = null;
            if (sourceIndex == targetIndex) {
                throw new Error("sourceIndex is the same as targetIndex");
            }
            for (let i in dealLineData) {
                if (dealLineData[i].index == sourceIndex) {
                    source = dealLineData[i];
                } else if (dealLineData[i].index == targetIndex) {
                    target = dealLineData[i];
                }
            }
            if (!source || !target) {
                throw new Error("Can not find sourceRegion or targetRegion");
            }
            if (source.region.x > target.region.x) {
                let temp = source;
                source = target;
                target = temp;
            }
            let pointArr = _findPath(source, target, dealLineData, lineGap, maxOverlap);
            allPointArrs.push({ paths: pointArr, text: lineText });
            for (let i = 0; i < pointArr.length - 1; i++) {
                let arr = [];
                arr.push(pointArr[i]);
                arr.push(pointArr[i + 1]);
                let path = svg.append("path");
                path.attr("d", lineFunction(arr)).attr("stroke-width", '1px').attr("stroke", lineColor);
            }
        }

        let emptyDatas = _getAllEmptyData(dealLineData, lineGap, startY, lineHeight, maxOverlap, width, paddingLeft, paddingRight);
        _renderLineText(svg, allPointArrs, emptyDatas, lineHeight, lineGap);

        function _renderLineText(svg, allPointArrs, emptyDatas, lineHeight, lineGap) {
            let textRegions = [];
            for (let i in allPointArrs) {
                let paths = allPointArrs[i].paths;
                let lineText = allPointArrs[i].text;
                let fs = lineHeight - 10;
                fs = fs < 12 ? 12 : fs;
                fs = fs > 24 ? 24 : fs;
                let fw = lineText.length * fs / 2;
                let textRegion = null;
                let maxLenXLine = null;
                let maxLenYLine = null;
                let maxLenX = 0;
                let maxLenY = 0;
                for (let j = 0; j < paths.length - 1; j++) {
                    let point1 = paths[j];
                    let point2 = paths[j + 1];
                    let empr = []
                    if (point1.x == point2.x) {
                        let leny = Math.abs(point1.y - point2.y);
                        if (leny > maxLenY) {
                            maxLenY = leny;
                            maxLenYLine = [point1, point2];
                        }
                        empr = _getEmptyWhenXEq(emptyDatas, point1, point2);
                    } else if (point1.y == point2.y) {
                        let lenx = Math.abs(point1.x - point2.x);
                        if (lenx > maxLenX) {
                            maxLenX = lenx;
                            maxLenXLine = [point1, point2];
                        }
                        empr = _getEmptyWhenYEq(emptyDatas, point1, point2, lineGap);
                    }
                    let find = false;
                    for (let k in empr) {
                        if (empr[k].region.w < fw) {
                            continue;
                        }
                        if (point1.x == point2.x) {
                            let tx1 = point1.x - fw - lineGap / 2;
                            let tx2 = point1.x + lineGap / 2;
                            let fy = empr[k].region.y + empr[k].region.h / 2 + fs / 4;
                            let region = { x: 0, y: fy, w: fw, h: empr[k].region.h };
                            if (!_txIsOverlap(textRegions, empr[k].region.y, tx1 - lineGap / 2, tx1 + fw + lineGap / 2)) {
                                find = true;
                                region.x = tx1;
                                textRegion = region;
                                break;
                            } else if (!_txIsOverlap(textRegions, empr[k].region.y, tx2 + lineGap / 2, tx2 + fw + lineGap / 2)) {
                                find = true;
                                region.x = tx2;
                                textRegion = region;
                                break;
                            }
                        } else if (point1.y == point2.y) {
                            let maxs = point1.x > empr[k].region.x ? point1.x : empr[k].region.x;
                            let mine = point2.x < empr[k].region.x + empr[k].region.w ? point2.x : empr[k].region.x + empr[k].region.w;
                            let fy = empr[k].region.y < point1.y ? empr[k].region.y + empr[k].region.h / 2 : empr[k].region.y;
                            let fx = maxs + (mine - maxs - fw) / 2;
                            let region = { x: fx, y: fy, w: fw, h: empr[k].region.h };
                            //横向时,需找出所在空白区间所有可能位置
                            let tr = _txIsOverlap(textRegions, empr[k].region.y, region.x - lineGap / 2, region.x + region.w + lineGap / 2);
                            if (!tr) {
                                find = true;
                                textRegion = region;
                                break;
                            } else {
                                region.x = maxs;
                                tr = _txIsOverlap(textRegions, empr[k].region.y, region.x - lineGap / 2, region.x + region.w + lineGap / 2);
                                let tf = true;
                                while (tr) {
                                    region.x = tr.x + tr.w + lineGap / 2;
                                    if (region.x > mine) {
                                        tf = false;
                                        break;
                                    }
                                    tr = _txIsOverlap(textRegions, empr[k].region.y, region.x - lineGap / 2, region.x + region.w + lineGap / 2)
                                }
                                if (tf) {
                                    find = true;
                                    textRegion = region;
                                    break;
                                }
                            }
                        }
                    }
                    if (find) {
                        break;
                    }
                }
                if (textRegion == null) {
                    textRegion = {}
                    if (maxLenXLine != null) {
                        let x1 = Math.min(maxLenXLine[0].x, maxLenXLine[1].x);
                        let x2 = Math.max(maxLenXLine[0].x, maxLenXLine[1].x);
                        textRegion.x = x1 + (x2 - x1 - fw) / 2;
                        textRegion.y = maxLenXLine[0].y + fs / 4;
                    } else if (maxLenYLine != null) {
                        let y1 = Math.min(maxLenYLine[0].y, maxLenYLine[1].y);
                        let y2 = Math.max(maxLenYLine[0].y, maxLenYLine[1].y);
                        textRegion.x = maxLenYLine[0].x - fw / 2;
                        textRegion.y = y1 + (y2 - y1) / 2 + fs / 4;
                    } else {
                        textRegion = null;
                        console.log("Can not find textRegion,text:" + lineText);
                    }
                }
                if (textRegion != null) {
                    let text = svg.append("text");
                    text.text(lineText);
                    text.attr('x', textRegion.x).attr('y', textRegion.y).attr("font-size", fs).attr("stroke-width", '1px');
                    textRegions.push(textRegion);
                }
            }
        }

        function _txIsOverlap(regions, ry, tx1, tx2) {
            for (let i in regions) {
                if (regions[i].y == ry && _isOverLap(regions[i].x, regions[i].x + regions[i].w, tx1, tx2)) {
                    return regions[i];
                }
            }
            return false;
        }

        function _getEmptyWhenXEq(emptyDatas, point1, point2) {
            let miny = point1.y < point2.y ? point1.y : point2.y;
            let maxy = point1.y > point2.y ? point1.y : point2.y;
            let px = point1.x;
            let result = [];
            for (let i in emptyDatas) {
                if (emptyDatas[i].region.y >= miny && emptyDatas[i].region.y <= maxy && emptyDatas[i].region.x <= px && emptyDatas[i].region.x + emptyDatas[i].region.w >= px) {
                    result.push(emptyDatas[i]);
                }
            }
            return result;
        }

        function _getEmptyWhenYEq(emptyDatas, point1, point2, lineGap) {
            let minx = point1.x < point2.x ? point1.x : point2.x;
            let maxx = point1.x > point2.x ? point1.x : point2.x;
            let py = point1.y
            let result = [];
            for (let i in emptyDatas) {
                let ry = emptyDatas[i].region.y;
                let ry2 = ry + emptyDatas[i].region.h;
                let ex1 = emptyDatas[i].region.x;
                let ex2 = ex1 + emptyDatas[i].region.w;
                if ((ry >= py && ry - lineGap < py) || (ry2 <= py && ry2 + lineGap > py) || (ry <= py && ry2 >= py)) {
                    if ((minx > ex1 && minx < ex2) || (maxx > ex1 && maxx < ex2) || (ex1 > minx && ex1 < maxx) || (ex2 > minx && ex2 < maxx)) {
                        result.push(emptyDatas[i]);
                    }
                }
            }
            return result;
        }


        function _getAllEmptyData(dealLineData, lineGap, startY, lineHeight, maxOverlap, width, paddingLeft, paddingRight) {
            let arr = [];
            for (let i = 1; i < maxOverlap + 1; i++) {
                let lastData = null;
                let ty = _getYByPosAndData(i, startY, lineHeight, lineGap);
                for (let j in dealLineData) {
                    if (dealLineData[j].position == i) {
                        let tw;
                        let tx;
                        if (lastData != null) {
                            tw = dealLineData[j].region.x - lastData.region.x - lastData.region.w - 2 * lineGap;
                            tx = lastData.region.x + lastData.region.w + lineGap;
                        } else {
                            tw = dealLineData[j].region.x - paddingLeft - lineGap;
                            tx = paddingLeft;
                        }
                        if (tw > 0) {
                            arr.push({ region: { x: tx, y: ty, w: tw, h: lineHeight }, position: i });
                        }
                        lastData = dealLineData[j];
                    }
                }
                if (lastData == null) {
                    arr[0].region.w = width - paddingRight - arr[0].region.x;
                } else {
                    let tx = lastData.region.x + lastData.region.w + lineGap;
                    let tw = width - paddingRight - tx;
                    if (tw > 0) {
                        arr.push({ region: { x: tx, y: ty, w: tw, h: lineHeight }, position: i });
                    }
                }
            }
            return arr;
        }

        function _findPath(source, target, dealLineData, lineGap, maxOverlap) {
            let toTop = source.region.y > target.region.y;
            if (source.position == target.position) {
                toTop = source.position >= maxOverlap / 2;
            }
            let startPoints = _getStartPoints(source, target, dealLineData, lineGap);
            let finalPointArr = null;
            for (let i = 0; i < startPoints.length; i++) {
                let findRight = i == 0;
                let pointArr = _findAndGetResult(startPoints[i], target.region, dealLineData, toTop, lineGap, findRight);
                finalPointArr = finalPointArr == null ? pointArr : (pointArr.length < finalPointArr.length ? pointArr : finalPointArr);
            }
            return finalPointArr;
        }

        //根据当前点，获取合适的开始区间的点。
        function _getStartPoints(source, target, dealLineData, lineGap) {
            let targetRegion = target.region;
            let sourceRegion = source.region;

            let startPoint1 = { x: sourceRegion.x + sourceRegion.w, y: sourceRegion.y + sourceRegion.h / 2 };
            let startPoint2 = { x: sourceRegion.x + sourceRegion.w, y: sourceRegion.y + sourceRegion.h };
            let startPoint3 = { x: sourceRegion.x + sourceRegion.w, y: sourceRegion.y };

            let arr = [];
            arr.push(startPoint1);
            if (sourceRegion.y == targetRegion.y) {
                arr.push(startPoint2);
                arr.push(startPoint3);
            } else if (sourceRegion.y > targetRegion.y) {
                arr.push(startPoint3);
            } else {
                arr.push(startPoint2);
            }
            return arr;
        }

        //根据当前点，获取合适的结束区间的目标点。
        function _getEndPoints(endRegion, curPoint, lineGap) {
            let point1 = { x: endRegion.x, y: endRegion.y + endRegion.h / 2 };
            let endPoint1 = { x: endRegion.x, y: endRegion.y + endRegion.h / 2 };

            let point2 = { x: endRegion.x, y: endRegion.y + endRegion.h + lineGap / 2 };
            let endPoint2 = { x: endRegion.x, y: endRegion.y + endRegion.h };

            let point3 = { x: endRegion.x, y: endRegion.y - lineGap / 2 };
            let endPoint3 = { x: endRegion.x, y: endRegion.y };

            let arr = [];
            let arr2 = [];
            arr.push(point1);
            arr2.push(endPoint1);
            if (curPoint && curPoint.y != endRegion.y) {
                if (curPoint.y > endRegion.y) {
                    arr.push(point2);
                    arr2.push(endPoint2);
                } else {
                    arr.push(point3);
                    arr2.push(endPoint3);
                }
            } else {
                arr.push(point2);
                arr.push(point3);
                arr2.push(endPoint2);
                arr2.push(endPoint3);
            }
            return { tEndPoints: arr, endPoints: arr2 };
        }

        function _getCenterPoint(curPoint, endPoint, findRight) {
            let x = findRight ? endPoint.x : curPoint.x;
            let y = findRight ? curPoint.y : endPoint.y;
            return { x: x, y: y };
        }

        //dp动态规划，往右上或右下寻找转弯最少的线
        function _findAndGetResult(startPoint, endRegion, dealLineData, toTop, lineGap, findRight) {
            let obj = _getEndPoints(endRegion, null, lineGap);
            let rResult = findRight ? _find(startPoint, endRegion, dealLineData, toTop, true, lineGap) : null;
            let tResult = findRight ? null : _find(startPoint, endRegion, dealLineData, toTop, false, lineGap);
            let nRResult = _getNewFindResult(rResult, endRegion, obj);
            let nTResult = _getNewFindResult(tResult, endRegion, obj);
            let minResult = [];
            minResult = _addResult(nRResult, nTResult, minResult);
            minResult = minResult.length == 0 ? null : minResult;
            return minResult;
        }

        function _getNewFindResult(fResult, endRegion, obj) {
            if (!fResult) {
                return null;
            }
            let arr = [];
            for (let i in fResult) {
                arr.push(fResult[i]);
            }
            let lp = fResult[fResult.length - 1];
            let endPoints = obj.endPoints;
            let tEndPoints = obj.tEndPoints;
            for (let i = 0; i < tEndPoints.length; i++) {
                let endPoint = tEndPoints[i];
                if (endPoint.x == lp.x && endPoint.y == lp.y) {
                    arr.push(endPoints[i]);
                    break;
                }
            }
            return arr;
        }

        function _find(curPoint, endRegion, dealLineData, toTop, findRight, lineGap) {
            let obj = _getEndPoints(endRegion, curPoint, lineGap);
            let tEndPoints = obj.tEndPoints;
            let minResult = null;
            for (let i = 0; i < tEndPoints.length; i++) {
                let endPoint = tEndPoints[i];
                let rResult = _findPoints(curPoint, endRegion, endPoint, dealLineData, toTop, lineGap, findRight);
                if (rResult == null) {
                    continue;
                }
                _simpleResult(rResult)
                if (minResult == null) {
                    minResult = rResult;
                } else {
                    minResult = rResult.length < minResult.length ? rResult : minResult;
                }
            }
            return minResult;
        }

        //找点
        function _findPoints(curPoint, endRegion, endPoint, dealLineData, toTop, lineGap, findRight) {
            let centerPoint = _getCenterPoint(curPoint, endPoint, findRight);
            let curPass = _linePassRegion(curPoint, centerPoint, dealLineData, lineGap);
            let endPass = _linePassRegion(endPoint, centerPoint, dealLineData, lineGap);
            let result = [];
            result.push(curPoint);
            let passResult = curPass.pass ? curPass : (endPass.pass ? endPass : null);
            if (passResult) {
                let breakRegion = passResult.breakData.region;
                let tx = findRight ? breakRegion.x - lineGap / 2 : curPoint.x;
                if (tx < curPoint.x) {
                    return null;
                }
                let ty = findRight ? curPoint.y : (toTop ? breakRegion.y + breakRegion.h + lineGap / 2 : breakRegion.y - lineGap / 2);
                let nPoint = { x: tx, y: ty };
                let rResult = _find(nPoint, endRegion, dealLineData, toTop, !findRight, lineGap);
                if (rResult == null) {
                    return null;
                }
                result = _addResult(rResult, null, result);
            } else {
                if ((centerPoint.x == endPoint.x && centerPoint.y == endPoint.y) || (centerPoint.x == curPoint.x && centerPoint.y == curPoint.y)) {} else {
                    result.push(centerPoint);
                }
                result.push(endPoint);
            }
            return result;
        }

        function _addResult(result1, result2, result) {
            if (result1 && result2) {
                _simpleResult(result1);
                _simpleResult(result2);
                let fResult = result2.length < result1.length ? result2 : result1;
                for (let i in fResult) {
                    result.push(fResult[i]);
                }
            } else if (result1) {
                for (let i in result1) {
                    result.push(result1[i]);
                }
            } else if (result2) {
                for (let i in result2) {
                    result.push(result2[i]);
                }
            }
            _simpleResult(result);
            return result;
        }

        function _simpleResult(result) {
            let len = result.length - 2;
            let sindex = [];
            for (let i = 0; i < len; i++) {
                let p1 = result[i];
                let p2 = result[i + 1];
                let p3 = result[i + 2];
                if (p1.x == p2.x && p2.x == p3.x) {
                    sindex.push(i + 1);
                } else if (p1.y == p2.y && p2.y == p3.y) {
                    sindex.push(i + 1);
                }
            }
            for (let i = 0; i < sindex.length; i++) {
                let index = sindex[i] - i;
                result.splice(index, 1);
            }
        }

        function _linePassRegion(startPoint, endPoint, dealLineData, lineGap) {
            let data = null;
            if (startPoint.x == endPoint.x) {
                let f = startPoint.y < endPoint.y;
                let miny = startPoint.y < endPoint.y ? startPoint.y : endPoint.y;
                let maxy = startPoint.y > endPoint.y ? startPoint.y : endPoint.y;
                for (let i in dealLineData) {
                    let region = dealLineData[i].region;
                    let rw = region.y + region.h;
                    if (region.x < startPoint.x - lineGap / 2 && region.x + region.w > startPoint.x + lineGap / 2 &&
                        (region.y > miny && rw < maxy || rw > maxy && region.y < maxy || region.y < miny && rw > miny)) {
                        data = dealLineData[i];
                        if (f) {
                            break;
                        }
                    }
                }
            } else if (startPoint.y = endPoint.y) {
                let minx = startPoint.x < endPoint.x ? startPoint.x : endPoint.x;
                let maxx = startPoint.x > endPoint.x ? startPoint.x : endPoint.x;
                for (let i in dealLineData) {
                    let region = dealLineData[i].region;
                    let rw = region.x + region.w;
                    if (region.y < startPoint.y && region.y + region.h > startPoint.y &&
                        (region.x > minx && rw < maxx || region.x < minx && rw > minx ||
                            rw > maxx && region.x < maxx)) {
                        data = dealLineData[i];
                        break;
                    }
                }
            }
            let result = {};
            result.pass = data != null;
            result.breakData = data;
            return result;
        }

        function _findNearRegion(region, dealLineData, position, findRight) {
            let leftRegion = null;
            let rightRegion = null;
            let isTarget = false;
            for (let i in dealLineData) {
                if (dealLineData[i].position == position) {
                    if (dealLineData[i].region == region) {
                        isTarget = true;
                    } else if (!isTarget) {
                        leftRegion = dealLineData[i].region;
                    } else if (isTarget) {
                        rightRegion = dealLineData[i].region;
                        break;
                    }
                }
            }
            return findRight ? rightRegion : leftRegion;
        }
    }

    //渲染染色矩形
    function _renderRect(svg, rectData, startY, height) {
        for (let i in rectData) {
            let rect = svg.append("rect");
            let h = height * rectData[i].height;
            let y = startY + (height - h) / 2;
            rect.attr("x", rectData[i].region[0]).attr("y", y).attr("width", rectData[i].region[1] - rectData[i].region[0]).attr("height", h);
            // rect.attr("opacity", 0.7);
            rect.attr("fill", rectData[i].color);
        }
    }

    //渲染坐标轴
    function _renderAxis(svg, pro, lineData, mainStartY, mainHeight, width, paddingLeft, paddingRight) {
        let startArr = [];
        let endArr = [];
        for (let i in lineData) {
            startArr.push(lineData[i].region[0]);
            endArr.push(lineData[i].region[1]);
        }
        let topY = mainStartY - 20;
        let bottomY = mainStartY + mainHeight + 20;
        _renderAxisPath(svg, pro, startArr, topY, true, width, paddingLeft, paddingRight, "gene start locations");
        _renderAxisPath(svg, pro, endArr, bottomY, false, width, paddingLeft, paddingRight, "gene end locations");
    }

    function _sortAxisArr(arr) {
        for (let i = 0; i < arr.length - 1; i++) {
            for (let j = 0; j < arr.length - i - 1; j++) {
                if (arr[j] > arr[j + 1]) {
                    let temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
    }

    var lineFunction = d3.line().x(function(d) { return d.x; }).y(function(d) { return d.y; });

    function _renderAxisPath(svg, pro, arrData, y, isTop, width, paddingLeft, paddingRight, descText) {
        _sortAxisArr(arrData);
        let basePath = svg.append("path");
        let baseLine = [{ "x": paddingLeft, "y": y }, { "x": width - paddingRight, "y": y }];
        basePath.attr("d", lineFunction(baseLine)).attr("stroke-width", '1px').attr("stroke", '#000');
        let y1 = y - Math.floor(axisScaleLenght / 2);
        let y2 = y + Math.ceil(axisScaleLenght / 2);
        let x1 = paddingLeft;
        let lx = x1;
        let maxlen = 0;
        for (let i in arrData) {
            let path = svg.append("path");
            let dx = arrData[i] * pro + paddingLeft;
            let len = dx - lx;
            if (len > maxlen) {
                maxlen = len;
                x1 = lx;
            }
            lx = dx;
            let data = [{ "x": dx, "y": y1 }, { "x": dx, "y": y2 }];
            path.attr("d", lineFunction(data)).attr("stroke-width", '1px').attr("stroke", '#000');
            let textData = _getTextDataArr(arrData[i]);
            let ty = isTop ? (y1 - 3 - textData.length * axisTextFontSize) : y2 + 1;
            let text = svg.append("text").attr("x", dx - 4).attr("y", ty).attr("font-size", axisTextFontSize);
            text.selectAll("tspan").data(textData).enter().append("tspan").attr("x", text.attr("x")).attr("dy", "1em")
                .text(function(d) {
                    return d;
                });
        }
        let len = width - paddingRight - lx;
        if (len > maxlen) {
            maxlen = len;
            x1 = lx;
        }
        let fw = descText.length * axisTextFontSize / 2;
        let fy = isTop ? y1 - 3 : y2 + 6;
        let fx = x1 + (maxlen - fw) / 2;
        svg.append("text").attr("x", fx).attr("y", fy).attr("font-size", axisTextFontSize).text(descText);
    }

    function _getTextDataArr(data) {
        let textData = [];
        let dataStr = data + "";
        for (let i = 0; i < dataStr.length; i++) {
            textData.push(dataStr[i]);
        }
        return textData;
    }

    //渲染区域，序列区域
    function _renderRegion(svg, dealLineData, lineColor, showText, textPosition, width) {
        let textData = [];
        for (let i in dealLineData) {
            let rect = svg.append("rect");
            rect.attr("x", dealLineData[i].region.x).attr("y", dealLineData[i].region.y).attr("width", dealLineData[i].region.w).attr("height", dealLineData[i].region.h);
            rect.attr("fill", lineColor);
            if (showText && dealLineData[i].text) {
                let testObj = {};
                let content = dealLineData[i].text;
                testObj.text = content;
                let fs = dealLineData[i].region.h - 10;
                fs = fs < 12 ? 12 : fs;
                fs = fs > 24 ? 24 : fs;
                let fw = content.length * fs * 3 / 4;
                if (fw > dealLineData[i].region.w) {
                    fs = dealLineData[i].region.w * 2 / content.length;
                    fw = content.length * fs / 2;
                }
                let tx = dealLineData[i].region.x + (dealLineData[i].region.w - fw) / 2;
                let end = tx + fw
                if (end > width) {
                    tx -= (end - width);
                }
                testObj.x = tx;
                if (!textPosition || textPosition == 'inside') {
                    testObj.y = dealLineData[i].region.y + dealLineData[i].region.h / 2 + fs / 4;
                } else if (textPosition == 'top') {
                    testObj.y = dealLineData[i].region.y - 2
                } else if (textPosition == 'bottom') {
                    testObj.y = dealLineData[i].region.y + dealLineData[i].region.h + fs / 4 + 2;
                }
                testObj.fs = fs;
                textData.push(testObj);
            }
        }
        for (let i in textData) {
            let testObj = textData[i];
            let text = svg.append("text");
            text.text(testObj.text);
            text.attr('x', testObj.x).attr('y', testObj.y).attr("font-size", testObj.fs).attr("stroke-width", '1px');
        }
    }

    function _getLineDataMax(lineData) {
        let max = 0;
        for (let i in lineData) {
            if (lineData[i].region[0] > max) {
                max = lineData[i].region[0];
            }
            if (lineData[i].region[1] > max) {
                max = lineData[i].region[1];
            }
        }
        return max;
    }

    //增加index属性记录原来的index，再排序
    function _dealSortLineData(arr) {
        for (let i = 0; i < arr.length; i++) {
            arr[i].index = i;
        }
        for (let i = 0; i < arr.length - 1; i++) {
            for (let j = 0; j < arr.length - i - 1; j++) {
                if (arr[j].region[0] > arr[j + 1].region[0]) {
                    let temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
        return arr;
    }

    //根据数据和比例，计算出实际像素位置
    function _getDealLineData(pro, oLineData, startY, mainHeight, lineHeight, maxOverlap, lineGap, paddingLeft, lineDataPositions) {
        let lineData = $.extend(true, [], oLineData);
        lineData = _dealSortLineData(lineData);
        let result = [];
        let posNum = 1;
        for (let i = 0; i < lineData.length; i++) {
            let obj = {};
            obj.text = lineData[i].text;
            obj.index = lineData[i].index;
            let tx = lineData[i].region[0] * pro + paddingLeft;

            let tp;
            let findNum = 0;
            if (!lineData[i].position) {
                let tk = i + "";
                if (lineDataPositions[tk]) {
                    tp = lineDataPositions[tk];
                } else {
                    tp = posNum;
                    while (true) {
                        let pass = true;
                        for (let j in result) {
                            if (result[j].position == tp) {
                                let tRegion = result[j].region;
                                if (tx < tRegion.x + tRegion.w + lineGap / 2) {
                                    pass = false;
                                    break;
                                }
                            }
                        }
                        if (!pass) {
                            tp++;
                            findNum++;
                            tp = tp > maxOverlap ? 1 : tp;
                        } else {
                            posNum = posNum == 1 ? maxOverlap : 1;
                            break;
                        }
                        if (findNum > maxOverlap) {
                            // throw new Error("error");
                            console.log("Can not find position");
                            console.log(lineData[i]);
                            break;
                        }
                    }
                }
            } else {
                tp = lineData[i].position;
            }

            obj.position = tp;
            let y = _getYByPosAndData(obj.position, startY, lineHeight, lineGap);
            obj.region = {};
            obj.region.x = tx;
            obj.region.y = y;
            obj.region.w = lineData[i].region[1] * pro + paddingLeft - obj.region.x;
            obj.region.h = lineHeight;
            obj.lineData = lineData[i]
            result.push(obj);
        }
        return result;
    }

    function _getYByPosAndData(pos, startY, lineHeight, lineGap) {
        return startY + (pos - 1) * (lineHeight + lineGap);
    }

    function _dealRectData(pro, data, paddingLeft) {
        let result = [];
        for (let i in data) {
            if (data[i].region) {
                let obj = {};
                obj.region = [data[i].region[0] * pro + paddingLeft, data[i].region[1] * pro + paddingLeft];
                obj.color = data[i].color ? data[i].color : "#aaa";
                obj.height = data[i].height ? data[i].height : 1;
                result.push(obj);
            }
        }
        return result;
    }

    return SeqRegionFun;
})();
export default new SeqRegion()


// WEBPACK FOOTER //
// ./src/assets/report/seqRegion.js